import { createApp } from "vue";

import App from "./App.vue";
import { router } from "./router/vue-router.js";
import { adminPinia } from "./stores/pinia.js";
import "./styles/admin-ui.css";

const root = document.querySelector<HTMLElement>("[data-price-rescue-admin-ui]");

if (root !== null) {
  createApp(App).use(adminPinia).use(router).mount(root);
}
